import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Subject, finalize } from 'rxjs';

import { MessageService } from '../services/message.service';
import { InMessageFile, Media } from '../shared';
import { UploadMonitor } from './upload-monitor';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
})
export class FileUploadComponent {
  @Output() fileChosen = new EventEmitter<UploadMonitor>(); // emitted when file starts uploading

  @ViewChild('fileInput', { static: true }) private fileInput: any;

  constructor(private messageService: MessageService) {}

  onFileInputChange(files: FileList) {
    const file = files.item(0); // only handle one file per upload
    if (file) {
      const monitor = new FileUploader(this.messageService, file).upload(
        () => (this.fileInput.nativeElement.value = '')
      );
      this.fileChosen.emit(monitor);
    }
  }
}

/**
 * private helper class that keeps some state between chunk uploads
 */
class FileUploader {
  progress: Subject<number>;
  media: Media; // media id allocated by backend on first POST to /media
  monitor: UploadMonitor;

  constructor(
    private messageService: MessageService,
    private file: File
  ) {}

  upload(cb: any): UploadMonitor {
    this.progress = new Subject();
    this.monitor = new UploadMonitor(this.file.name, this.progress);
    this.messageService
      .uploadFile(this.file, this.progress)
      .pipe(finalize(() => cb()))
      .subscribe({
        next: fileUUID => {
          this.monitor.file = new InMessageFile(fileUUID);
          this.progress.complete();
        },
        error: this.errorHandler(`upload of file ${this.file.name}`),
      });
    return this.monitor;
  }

  /*
   * Returns an error handler that logs any error and forwards it to subscribers of the progress monitor
   */
  errorHandler(message: string) {
    return (error: any) => {
      console.log(message, error);
      this.progress.error(error);
    };
  }
}
